import React from 'react'
import * as SurveyJS from 'survey-react'

import CreatableSelectWrapper from './CreatableSelectWrapper'

const MultiSelectWidget = {
  name: 'multiselectwidget',
  title: 'multiselectwidget',
  iconName: 'icon-default',
  widgetIsLoaded: function() {
    return true
  },
  isFit: function(question) {
    const applicableQuestions = ['Xplor_ChildMedicalAllergies', 'Xplor_ChildDietary']

    return applicableQuestions.includes(question.name)
  },
  activatedByChanged: function() {
    SurveyJS.JsonObject.metaData.addClass('multiselectwidget', [], null, 'dropdown')
  },
  // eslint-disable-next-line react/display-name
  render: question => {
    return <CreatableSelectWrapper question={question} isMulti />
  }
}

export default MultiSelectWidget
